
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1_3787)"}},[_c('path',{attrs:{"d":"M3.785 8.235V5.561c0-.193.027-.381.08-.561H2.06c-.293 0-.558.119-.75.311a1.058 1.058 0 00-.311.75v2.128a1.057 1.057 0 00.542.924v3.093c0 .226.183.41.41.41h2.514v-2.86a2.055 2.055 0 01-.681-1.52z"}}),_c('path',{attrs:{"d":"M2.604 5.207c.884 0 1.603-.719 1.603-1.603C4.207 2.719 3.488 2 2.604 2 1.719 2 1 2.72 1 3.604c0 .884.72 1.603 1.604 1.603zM8.12 5H5.228c-.338 0-.645.138-.868.36-.222.223-.36.53-.36.868v2.675A1.223 1.223 0 004.68 10v3.95c0 .226.184.41.41.41h3.167a.41.41 0 00.41-.41v-3.95a1.232 1.232 0 00.68-1.098V6.228c0-.338-.137-.645-.36-.868A1.224 1.224 0 008.12 5zM6.91 3.82c1.054 0 1.91-.856 1.91-1.91C8.82.857 7.965 0 6.91 0 5.857 0 5 .857 5 1.91c0 1.054.857 1.91 1.91 1.91zM13.21 5.311A1.058 1.058 0 0012.46 5H10.6c.052.18.08.368.08.56v2.675c0 .58-.251 1.133-.681 1.521v2.857a.423.423 0 00.05.002h2.52a.41.41 0 00.409-.409V9.113a1.067 1.067 0 00.542-.924V6.06c0-.293-.12-.558-.312-.75z"}}),_c('path',{attrs:{"d":"M10.604 5.207c.884 0 1.603-.719 1.603-1.603 0-.885-.719-1.604-1.603-1.604C9.719 2 9 2.72 9 3.604c0 .884.72 1.603 1.604 1.603z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1_3787"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    